export const useAdjacentPosts = (post: MaybeRef<PostItem>) => {
  const { getAdjacentPost } = usePosts();

  const { data: prev } = useAsyncData<PostItem | null>(
    `${post.value.type}:${post.value.slug}:prev`,
    async () => (post?.value ? getAdjacentPost("prev", post) : null),
    { default: () => null, watch: [post] }
  );

  const { data: next } = useAsyncData<PostItem | null>(
    `${post.value.type}:${post.value.slug}:next`,
    async () => (post?.value ? getAdjacentPost("next", post) : null),
    { default: () => null, watch: [post] }
  );

  return { prev, next };
};
